import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { MsalProvider } from '@azure/msal-react'
import { loadAppConfig } from '@/lib/app-config'
import { initializeMsal } from '@/lib/msal-config'
import { AuthenticationProvider } from '@/features/auth/AuthenticationContext'
import { AuthorizationProvider } from '@/features/authorization/AuthorizationContext'
import App from './App.tsx'
import './index.css'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

// Load runtime config from backend, then initialize MSAL and render.
async function bootstrap() {
  await loadAppConfig()
  const msalInstance = initializeMsal()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <AuthenticationProvider>
              <AuthorizationProvider>
                <App />
              </AuthorizationProvider>
            </AuthenticationProvider>
          </MsalProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  )
}

bootstrap().catch((err) => {
  console.error('Failed to bootstrap application:', err)
  document.getElementById('root')!.innerHTML =
    '<div style="padding:2rem;text-align:center;color:#ef4444;">' +
    '<h1>Failed to load application</h1>' +
    '<p>Could not connect to the server. Please try again later.</p>' +
    '</div>'
})
